import { render, staticRenderFns } from "./OtherServicesFiltersComponent.vue?vue&type=template&id=3f0acbf8&"
import script from "./OtherServicesFiltersComponent.vue?vue&type=script&lang=ts&"
export * from "./OtherServicesFiltersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./OtherServicesFiltersComponent.vue?vue&type=style&index=0&id=3f0acbf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports